import { render, staticRenderFns } from "./bet.vue?vue&type=template&id=3a57e0aa&scoped=true&"
import script from "./bet.vue?vue&type=script&lang=js&"
export * from "./bet.vue?vue&type=script&lang=js&"
import style0 from "./bet.vue?vue&type=style&index=0&id=3a57e0aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57e0aa",
  null
  
)

export default component.exports